// Experiment: a popup-free SSO login, open to the accounts listed in the backend's
// GOOGLE_CREDENTIAL_LOGIN_EMAILS. The path is deliberately unguessable so nobody lands on it by
// accident; it is not an access control, the backend allow-list is.
export const EXPERIMENTAL_SSO_LOGIN_PATH = 'login-sso-a47f13c9'
